import React from 'react';
import { APP_ROUTES } from 'swag-client-common/constants/app-routes';
import { browserHistory } from 'react-router';
import { PopupDialog } from 'swag-client-common/components/info/popup-dialog';
import { Button } from 'swag-client-common/components/ui/button';
import { OOS_ERROR_TEXT } from 'swag-common/constants/error.const';
import s from './checkout-out-of-stock-adjustment-popup.scss';
const classes = {
  paper: s.paper
};
const goTo = () => browserHistory.push(APP_ROUTES.CART);
const CheckoutOutOfStockAdjustmentPopup = ({
  isOpen,
  onClose,
  isSomeItemsHidden
}) => {
  return /*#__PURE__*/React.createElement(PopupDialog, {
    dataPopup: "CheckoutOutOfStockAdjustmentPopup",
    showCloseButton: true,
    open: isOpen,
    contentClass: s.contentClass,
    titleHeader: s.titleHeader,
    classes: classes,
    onClose: () => onClose(),
    title: renderTitle(isSomeItemsHidden),
    content: renderContent({
      onClose,
      isSomeItemsHidden
    })
  });
};
const outOfStockTitle = 'Products that you want to purchase are out of stock!';
const hiddenProductTitle = 'Products that you want to purchase are no longer available!';
const renderTitle = isSomeItemsHidden => /*#__PURE__*/React.createElement("div", {
  className: s.title
}, isSomeItemsHidden ? hiddenProductTitle : outOfStockTitle);
const hiddenProductMessage = 'Some of the products that are in your cart are no longer available. This may be because the product has been discontinued or has no stock available. Please let us know if you have any questions.';
const renderContent = ({
  onClose,
  isSomeItemsHidden
}) => /*#__PURE__*/React.createElement("div", {
  className: s.contentWrapper
}, /*#__PURE__*/React.createElement("span", {
  className: s.contentText
}, isSomeItemsHidden ? hiddenProductMessage : OOS_ERROR_TEXT), /*#__PURE__*/React.createElement(Button, {
  type: "primary",
  size: "small",
  onClick: () => onClose(goTo),
  dataButton: "GoBacktoCart",
  className: s.button
}, "Go Back to Cart"));
export default CheckoutOutOfStockAdjustmentPopup;